import React from 'react';
import { observer } from 'mobx-react-lite';
import { BURNED_CARDS_BOX } from '../../enums/cardTypes';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';
import { cardsStore } from '../../store/cardsStore';

export const BurningCards = observer(() => {
  const { burnedCards, selectedCardBackSideType, burnedCardsCount } = cardsStore;
  const burnedCardsIds = useIdsGenerator(BURNED_CARDS_BOX, [burnedCards]);
  return (
    <div className='football-field-center-cards'>
      {BURNED_CARDS_BOX.map((item, index) => {
        if (index < 1 || burnedCardsCount < index) {
          return null;
        }
        if (burnedCards.length > index) {
          return (
            <div
              key={burnedCardsIds[index]}
              className={`football-field-center-card ${selectedCardBackSideType} anim`}
            />
          );
        }
        return <div key={burnedCardsIds[index]} className='football-field-center-card' />;
      })}
    </div>
  );
});
